<span id="errorcode">{{code}}</span>
<span id="errormessage">{{message}}</span>
<button *ngIf="urlBack" (click)="tornaAlServizio()" class="btn btn-outline-primary" type="button">
  Torna al servizio
</button>
